<script setup lang="ts">
import type { Survey } from '@/types/types'
import dayjs from 'dayjs'

const { survey } = defineProps<{
  survey: Survey
  dimmed?: boolean
}>()

const { t } = useI18n()

const surveyMetaLabel = computed(() => {
  const startDate = dayjs(survey.launchDate * 1000).format('DD/MM/YYYY')
  const count = survey.stores?.length

  if (survey.endDate) {
    return t('ui.textareaWithVars.survey.labelWithEndDate', {
      count,
      startDate,
      endDate: dayjs(survey.endDate * 1000).format('DD/MM/YYYY')
    })
  }

  return t('ui.textareaWithVars.survey.label', {
    count,
    startDate
  })
})
</script>

<template>
  <div class="flex flex-col" :class="{ 'px-2 py-1.5 opacity-50': dimmed }">
    <div>{{ survey.questionText }}</div>
    <div class="text-xs text-muted-foreground">
      {{ surveyMetaLabel }}
    </div>
  </div>
</template>
